module.exports = __webpack_public_path__ + "img/6E6D69_D0ECE9_AAC7C6_200C0C-256px.b795f397.png";